import { React, useState, useEffect, useRef } from "react";
import * as ReactDOM from "react-dom";
import {
  Grid,
  GridColumn as Column,
  GridToolbar,
} from "@progress/kendo-react-grid";
import { filterBy, orderBy } from "@progress/kendo-data-query";

import {
  Menu,
  MenuItem,
  MenuItemLink,
  MenuSelectEvent,
} from "@progress/kendo-react-layout";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { Button } from "@progress/kendo-react-buttons";
import HistoryDialog from "./HistoryDialog";

import { useNavigate } from "react-router-dom";

const initialSort: any[] = [
  {
    field: "infoGroupName",
    dir: "asc",
  },
];

interface MachineInfoGridProps {
  data?: any | null;
}

const MachineInfosGrid = (props: MachineInfoGridProps) => {
  const initialDataState: { skip: number; take: number } = {
    skip: 0,
    take: 100,
  };
  const [historyDialogVisible, updateHistoryDialogVisible] = useState(false);
  const [nodeId, updateNodeId] = useState(null);
  const [data, setData] = useState(props.data);
  const [sort, setSort] = useState(initialSort);
  const [isPagable, updateIsPagable] = useState(false);
  const [filter, setFilter] = useState<any>();
  const [page, setPage] = useState<{ skip: number; take: number }>(
    initialDataState
  );
  useEffect(() => {
    setData(props.data);
  }, [props.data]);

  const toggleHistoryDialog = () => {
    historyDialogVisible
      ? updateHistoryDialogVisible(false)
      : updateHistoryDialogVisible(true);
  };

  const pageChange = (event) => {
    setPage(event.page);
  };
  const filterChange = (event: any): void => {
    if (props.data != null) {
      setData(filterBy(props.data, event.filter));
      setFilter(event.filter);
    }
  };

  const openHistoryDialog = (infoValueId: number) => {
    updateNodeId(infoValueId);
    updateHistoryDialogVisible(true);
  };
  const historyCell = (cellProps: any) => {
    return (
      <td>
        <Button
          onClick={() => openHistoryDialog(cellProps.dataItem.infoValueId)}
        >
          History
        </Button>
      </td>
    );
  };
  const _export = useRef<ExcelExport | null>(null);
  const excelExport = (event: MenuSelectEvent) => {
    if (event.item.text === "Export to Excel") {
      if (_export.current !== null) {
        _export.current.save();
      }
    }
  };
  const linkRender = (props: any) => {
    return (
      <MenuItemLink url={props.item.url} opened={props.opened}>
        {[renderMenuIconIfApplicable(props), props.item.text, null]}
      </MenuItemLink>
    );
  };
  function renderMenuIconIfApplicable(props: any) {
    return props.item.icon ? (
      <span
        style={{ fontSize: "16px" }}
        className={`k-icon k-i-${props.item.icon}`}
        role="presentation"
        key="0"
      />
    ) : null;
  }
  return (
    <>
      <div
        className="machineInfoGrid"
        style={{ height: "calc(100% - 25px)", position: "relative" ,marginTop:"25px"}}
      >
        <div
          style={{
            position: "absolute",
            top: "-20px",
            left: "1px",
          }}
        >
          <Menu
            openOnClick={true}
            onSelect={excelExport}
            linkRender={linkRender}
          >
            <MenuItem
              text=""
              icon="more-horizontal"
              data={{}}
              cssStyle={{ color: "black" }}
            >
              <MenuItem text="Export to Excel" />
            </MenuItem>
          </Menu>
        </div>
        <ExcelExport data={data} ref={_export}>
          <Grid
            pageable={isPagable}
            // data={orderBy(data, sort).slice(page.skip, page.take + page.skip)}
            data={orderBy(data, sort).slice(page.skip, page.skip + page.take)}
            skip={page.skip}
            take={page.take}
            onPageChange={pageChange}
            scrollable={"virtual"}
            total={data.length}
            filterable={true}
            filter={filter}
            onFilterChange={filterChange}
            sortable={true}
            sort={sort}
            onSortChange={(e: any) => {
              setSort(e.sort);
            }}
            style={{
              width: "100%",
              height: "100%",
            }}
          >
            <Column field="infoGroupName" title="Group name" />
            <Column field="infoHeaderName" title="Header" />
            <Column field="infoValue" title="Value" />
            <Column field="description" title="Description" />
            <Column field="infoValueId" title="History" cell={historyCell} />
          </Grid>
        </ExcelExport>
      </div>
      <HistoryDialog
        visible={historyDialogVisible}
        toggleVisible={toggleHistoryDialog}
        nodeId={nodeId}
      />{" "}
    </>
  );
};
export default MachineInfosGrid;
